import OCGatewayClient from "../client/OCGatewayClient";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { DevicePaymentPlan } from "../models/DevicePaymentPlan";
import { gatewayRealtimeQueryOptions, mergeUpdateBodyIntoCachedObject } from "./gatewayQueryUtils";

let subscribed = false;

export function useDevicePaymentPlanQuery(deviceId: string) {
    const queryClient = useQueryClient();
    const query = useQuery({
        queryKey: ['getDevicePaymentPlan', deviceId],
        enabled: !!deviceId,
        queryFn: async (): Promise<DevicePaymentPlan | null> => {
            const result = await OCGatewayClient.request('getDevicePaymentPlan', {
                deviceId,
                subscribe: true
            });
            return result ? new DevicePaymentPlan(result) : null;
        },
        ...gatewayRealtimeQueryOptions
    });

    if (!subscribed) {
        OCGatewayClient.socket.on('devicePaymentPlanUpdate', (data: any) => {
            queryClient.setQueryData(['getDevicePaymentPlan', data.deviceId], (paymentPlan: DevicePaymentPlan) => {
                return mergeUpdateBodyIntoCachedObject(paymentPlan, data, 'devicePaymentPlanUpdate');
            });
        });

        subscribed = true;
    }

    return query;
}

export function useDevicePaymentPlanPreviewQuery(deviceId: string, priceType: string) {
    const query = useQuery({
        queryKey: ['getDevicePaymentPlanPreview', deviceId, priceType],
        enabled: !!deviceId,
        queryFn: async (): Promise<any | null> => {
            const result = await OCGatewayClient.request('getDevicePaymentPlanPreview', {
                deviceId,
                priceType
            });
            return result;
        },
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 60 * 24,
        networkMode: 'always',
        retry: false
    });

    return query;
}
